import { useEffect, useState } from "react";
import "./StarRating.css"; // Make sure to have proper CSS for filled/unfilled stars

export default function StarRating({
  rating = 0,
  onRate = () => {}, // safe default to avoid errors
  readOnly = false,
  size = 20 // allows dynamic font size
}) {
  const [hovered, setHovered] = useState(0);
  const [currentRating, setCurrentRating] = useState(rating);

  // Sync current rating if props.rating changes (e.g., after new review)
  useEffect(() => {
    setCurrentRating(rating);
  }, [rating]);

  const handleClick = (value) => {
    if (readOnly) return; // prevent interaction if readOnly
    setCurrentRating(value);
    onRate(value);
  };

  return (
    <div
      className={`star-rating ${readOnly ? "readonly" : ""}`}
      style={{ fontSize: `${size}px`, display: "inline-block" }}
    >
      {[1, 2, 3, 4, 5].map((star) => {
        const filled = star <= (hovered || currentRating);
        return (
          <span
            key={star}
            className={`star ${filled ? "filled" : "empty"}`}
            onMouseEnter={() => !readOnly && setHovered(star)}
            onMouseLeave={() => !readOnly && setHovered(0)}
            onClick={() => handleClick(star)}
            role="button"
            aria-label={`Rate ${star} star${star > 1 ? "s" : ""}`}
            style={{ cursor: readOnly ? "default" : "pointer", color: filled ? "#fbc02d" : "#ccc" }}
          >
            ★
          </span>
        );
      })}
    </div>
  );
}
